module.exports = __webpack_public_path__ + "img/12.1fab58c0.webp";